import React, { PropsWithChildren } from "react";

import { Box, BoxProps } from "@portex-pro/ui-components";
import Text from "components/Text";

type Props = {
  title: string;
  tag?: React.ReactNode;
  footer?: React.ReactNode;
  BoxProps?: BoxProps;
  headerBoxProps?: BoxProps;
  stepNumber?: number;
};

export const StepBlock: React.FC<PropsWithChildren<Props>> = ({
  title,
  tag,
  children,
  footer,
  BoxProps,
  headerBoxProps,
  stepNumber,
}) => {
  return (
    <Box
      paddingTop="16px"
      paddingBottom="16px"
      paddingLeft="24px"
      paddingRight="24px"
      bgcolor="white"
      borderRadius="8px"
      boxShadow="0 1px 3px rgba(0, 0, 0, 0.1)"
      {...BoxProps}
    >
      <Box display="flex" flexDirection="column" justifyContent="space-between" alignItems="center" width="100%">
        <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" {...headerBoxProps}>
          <Text size="large" weight="bold">
            {stepNumber ? `${stepNumber}. ` : ""}
            {title}
          </Text>
          {tag && <Box>{tag}</Box>}
        </Box>
        <Box flex={1} width="100%">
          {children}
        </Box>
        {footer}
      </Box>
    </Box>
  );
};
